import React from 'react'
import Layout from '../../../Layout'
import DriverListContainer from '../../../../../Components/UserPart/UserList/DriverListContainer/DriverListContainer'

const Driver = () => {
  return (
    <Layout>
        <DriverListContainer/>
    </Layout>
  )
}

export default Driver